import IconButton from '@mui/material/IconButton';
import React from 'react';


export const HIconButton = React.forwardRef((props, ref) => (
  <IconButton ref={ref} {...props} />
));
